import styled from '@emotion/styled';

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
  &:last-of-type {
    margin: 0;
  }
`;
